import React from 'react'
import { AppWindow, Code, Envelope, Link, Tag } from '@phosphor-icons/react'

const ContentSourceBadge = ({ source }) => {
  const getIcon = () => {
    switch (source) {
      case 'web':
        return <Link size={16} weight="bold" color="teal"/>
      case 'email':
        return <Envelope size={16} weight="bold" color="teal"/>
      case 'app':
        return <AppWindow size={16} weight="bold" color="teal"/>
      case 'api':
        return <Code size={16} weight="bold" color="teal"/>
      default:
        return <Tag size={16} weight="bold" color="teal"/>
    }
  }

  return (
    <div className="badge badge-outline badge-lg flex items-center gap-2">
      <div className="flex items-center gap-2">
        {getIcon()}
        {source}
      </div>
    </div>
  )
}

export default ContentSourceBadge